import React from 'react'
import { Flex, Radio, RadioProps, RadioGroup, RadioButtonGroupProps } from '@chakra-ui/core'
import { useField } from 'formik'
import { Text } from '../../../typography'
import { LabelProps } from '../styles'

type ConnectedRadioGroupProps = {
  label?: string
  name: string
  options: { label: string; value: string }[]
} & RadioButtonGroupProps & {
    labelProps?: LabelProps
    radioProps?: RadioProps
  } & React.HTMLAttributes<HTMLDivElement>

const ConnectedRadioGroup: React.FC<ConnectedRadioGroupProps> = ({
  label,
  name,
  options,
  labelProps = {},
  radioProps = {},
  ...props
}) => {
  const [field, meta, helpers] = useField(name)

  return (
    <Flex direction="column" {...props}>
      {label && (
        <Text as="label" fontSize="sm" {...labelProps}>
          {label}
        </Text>
      )}
      <RadioGroup
        name={name}
        variantColor="green"
        value={field.value}
        onChange={(e) => {
          helpers.setValue(e?.target.value || '')
        }}
      >
        {options.map((option) => {
          const isChecked = field.value === option.value
          return (
            <Radio
              key={option.value}
              value={option.value}
              p={3}
              size="md"
              bg={isChecked ? 'green.100' : 'gray.50'}
              border="1px solid"
              borderColor={isChecked ? 'green.50' : 'transparent'}
              borderRadius="lg"
              {...radioProps}
            >
              <Text fontSize="xs" color="gray.700" fontWeight="bold">
                {option.label}
              </Text>
            </Radio>
          )
        })}
      </RadioGroup>
      {meta.touched && meta.error && (
        <Text color="red.500" mt={2}>
          {meta.error}
        </Text>
      )}
    </Flex>
  )
}

export default ConnectedRadioGroup
